import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { titleCaps } from 'utils/universal'
import sx from './styles'

const VechileCard = (props) => {
  const {
    id,
    item,
    sx: sxProp,
    className: classNameProp,
    selected,
    onClick,
    ...others
  } = props
  const className = clsx('Version-card-root', classNameProp, {
    selected,
  })
  return (
    <Paper
      id={id}
      sx={{
        ...sx.root,
        ...sxProp,
      }}
      className={className}
      onClick={onClick}
      {...others}
    >
      <Box
        sx={sx.textContainer}
      >
        <Typography
          variant="body1"
          sx={sx.title}
        >
          {titleCaps(item.name)}
        </Typography>
      </Box>

      <Box
        sx={sx.textContainer}
        className="Tile-text"
        gutterBottom
      >
        {item.bodywork && (
          <Typography
            variant="body1"
          >
            {titleCaps(item.bodywork)}
          </Typography>
        )}

        {item.transmission && (
          <Typography
            variant="body1"
          >
            <FormattedMessage id="APPRAISAL_TRANSMITION" />
            {' '}
            {titleCaps(item.transmission)}
          </Typography>
        )}

        {item.absBrakes && (
          <Typography
            variant="body1"
          >
            <FormattedMessage id="APPRAISAL_ABS_BREAKS" />
          </Typography>
        )}
      </Box>

      <Box>
        {item.upholstered && (
          <Typography
            variant="body1"
          >
            <FormattedMessage id="APPRAISAL_SEATS" />
          </Typography>
        )}
        {item.sunroof && (
          <Typography
            variant="body1"
          >
            <FormattedMessage id="APPRAISAL_COCOS" />
          </Typography>
        )}
        {item.ac && (
          <Typography
            variant="body1"
          >
            <FormattedMessage id="APPRAISAL_AA" />
          </Typography>
        )}
      </Box>
    </Paper>
  )
}

export default memo(VechileCard)
